class Faqs2 extends window.HTMLElement {
  constructor() {
    super();
    this.handleFilterClick();
    this.handleQuestionClick();
    this.handleResultClick();
    this.init();
    this.initData();
    this.handleInputChange();
  }
  initData() {
    const faqs = $(".faq-item");
    const data = [];
    faqs.each(function (index, item) {
      const tags = $(item).data("filter");
      const question = $(item).find(".faq-title").text().trim();
      const answer = $(item).find(".faq-answer").text().trim();
      data.push({
        tags,
        question,
        answer,
      });
    });
    this.data = data.reduce((pre, next) => {
      const exiting = pre.find((item) => item.tags === next.tags);
      if (exiting) {
        exiting.faqs.push({
          question: next.question,
          answer: next.answer,
        });
      } else {
        pre.push({
          tags: next.tags,
          faqs: [
            {
              question: next.question,
              answer: next.answer,
            },
          ],
        });
      }
      return pre;
    }, []);
    this.questions = this.data.flatMap((item) =>
      item.faqs.map((ele) => ({
        tags: item.tags,
        question: ele.question,
      }))
    );
  }
  init() {
    const firstFilter = $(this).find(".filter-item")[0];
    $(firstFilter).addClass("filter-active");
    const tags = $(firstFilter).data("filter");
    const faqs = $(this).find(`.faq-item[data-filter='${tags}']`);
    faqs.each((index, item) => {
      $(item).css("display", "block");
      if (!index) {
        $(item).find(".faq-title").click();
      }
    });
  }
  handleFilterClick() {
    const _this = this;
    $(this)
      .find(".filter-item")
      .click(function () {
        $(_this).find(".filter-item").removeClass("filter-active");
        $(_this).find(".faq-item").css("display", "none");
        $(this).addClass("filter-active");

        const tags = $(this).data("filter");
        const faqs = $(_this).find(`.faq-item[data-filter='${tags}']`);
        faqs.each((index, item) => {
          $(item).css("display", "block");
          if (!index) {
            $(item).find(".faq-title").click();
          }
        });
      });
  }
  handleQuestionClick() {
    const _this = this;
    $(this)
      .find(".faq-title")
      .on("click", function () {
        var $qaItem = $(this).closest(".faq-item");
        $(_this)
          .find(".faq-item")
          .removeClass("active-qa")
          .find(".faq-answer")
          .css({
            "max-height": "0px",
            padding: "0",
          });
        $(_this)
          .find(".faq-item")
          .find(".close")
          .hide()
          .siblings(".open")
          .show();
        $qaItem
          .addClass("active-qa")
          .find(".faq-answer")
          .css({
            "max-height": $qaItem.find(".faq-answer")[0].scrollHeight + 20 + "px",
            padding: "0px 0 20px 0",
          });
        $(this).find(".open").hide().siblings(".close").show();
      });
  }
  handleInputChange() {
    const _this = this;
    $(this)
      .find(".faqs-search-ipt")
      .on("input", function () {
        const value = $(this).val();
        const searchResultContainer = $(_this).find(".search-result")[0];
        searchResultContainer.innerHTML = "";
        if (!value) return;
        const searchResult = _this.questions.filter((item) =>
          item.question.toLocaleLowerCase().includes(value.toLocaleLowerCase())
        );
        if (!searchResult.length) {
          const fragment = document.createDocumentFragment();
          const resultItem = document.createElement("div");
          resultItem.className = "result-blank";
          resultItem.textContent =
            "No results found. Please try your search again.";
          fragment.appendChild(resultItem);
          searchResultContainer.appendChild(fragment);
        } else {
          const fragment = document.createDocumentFragment();
          searchResult.forEach((result) => {
            const resultItem = document.createElement("div");
            resultItem.className = "search-result-item";
            resultItem.textContent = result.question;
            resultItem.dataset.filter = result.tags;
            fragment.appendChild(resultItem);
          });
          searchResultContainer.appendChild(fragment);
        }
      });
  }
  handleResultClick() {
    const _this = this;
    $(this)
      .find(".search-result")
      .on("click", ".search-result-item", function (e) {
        // 1.清空输入框
        $(_this).find(".faqs-search-ipt").val("");
        $(_this).find(".search-result")[0].innerHTML = "";
        // 2.左侧filter高亮
        const tags = $(_this).find(
          ".filter-item[data-filter='" + $(this).data("filter") + "']"
        );
        tags[0].click();
        // 3.右侧对应展开
        const faqs = $(_this).find(".faq-item").find(".faq-title");
        faqs.each((index, item) => {
          const question = $(item).text();
          if (question.trim() === $(this).text().trim()) {
            $(item).click();
          }
        });
      });
  }
}
window.customElements.define("faqs-2", Faqs2);
